
import * as Sentry from '@sentry/angular';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// GlitchTip (Sentry-compatible) — solo emite si hay DSN (prod/dev); local/staging no.
if (environment.SENTRY_DSN) {
  Sentry.init({
    dsn: environment.SENTRY_DSN,
    environment: environment.SENTRY_ENV,
    tracesSampleRate: 0, // solo errores, sin performance
  });
}

platformBrowserDynamic().bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
  .catch((err: any) => console.error(err));
